var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiTableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";
/**
 * @deprecated since version 2.5.0. Use TableContainer from epic-ui/table package.
 */
export var TableContainer = React.forwardRef(function TableContainer(_a, ref) {
    var className = _a.className, dense = _a.dense, PaperProps = _a.PaperProps, props = __rest(_a, ["className", "dense", "PaperProps"]);
    if (dense)
        return React.createElement(MuiTableContainer, __assign({}, props, { className: className, ref: ref }));
    return (React.createElement(Paper, __assign({}, PaperProps, { className: clsx(className, PaperProps === null || PaperProps === void 0 ? void 0 : PaperProps.className) }),
        React.createElement(MuiTableContainer, __assign({}, props, { ref: ref }))));
});
//# sourceMappingURL=TableContainer.js.map